import { useState, useEffect } from 'react';
import { Input } from '../../ui/input';
import { Label } from '@radix-ui/react-label';

const ShowPartnerKids = () => {
    const [partner, setPartner] = useState({});
    const [children, setChildren] = useState([]);

    useEffect(() => {
        // Données du partenaire
        const partnerData = {
            nom: localStorage.getItem('lastnamepartner') || '',
            prénom: localStorage.getItem('firstnamepartner') || '',
            lieu: localStorage.getItem('birthplacepartner') || ''
        };
        setPartner(partnerData);

        // Recherche tous les enfants
        const enfants = [];
        let index = 0;
        while (localStorage.getItem(`firstnamechild${index}`)) {
            enfants.push({
                nom: localStorage.getItem(`lastnamechild${index}`) || '',
                prénom: localStorage.getItem(`firstnamechild${index}`) || '',
                lieu: localStorage.getItem(`birthplacechild${index}`) || ''
            });
            index++;
        }

        setChildren(enfants);
    }, []);

    const hasPartnerData = partner.nom || partner.prénom || partner.naissance || partner.lieu;
    const hasChildrenData = children.length > 0;

    if (!hasPartnerData && !hasChildrenData) {
        return null;
    }

    return (
        <div className='flex flex-col items-center justify-center p-6'>
            <div className="flex flex-col md:flex-row gap-6 justify-center w-full">

                {/* Affichage du partenaire */}
                {hasPartnerData && (
                    <div className="mx-auto w-full max-w-md">
                        <div className='p-10 bg-white dark:bg-black flex justify-center'>
                            <div className="w-full border border-gray-700 rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
                                <h2 className='text-xl font-bold mb-2 text-black dark:text-white'>Conjoint(e)</h2>
                                <p className='text-2xl font-bold text-black dark:text-white'>{partner.nom} {partner.prénom}</p>
                                <p className='text-2xl font-bold text-black dark:text-white'>{partner.lieu}</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Affichage des enfants */}
                {hasChildrenData && (
                    <div className="mx-auto w-full max-w-md">
                        <div className='p-10 bg-white dark:bg-black flex justify-center'>
                            <div className="w-full border border-gray-700 rounded-lg p-6 shadow-md dark:bg-neutral-900 bg-gray-100">
                                <h2 className='text-xl font-bold mb-4 text-black dark:text-white'>Enfants</h2>
                                {children.map((child, index) => (
                                    <div key={index} className="mb-4 border-b pb-2">
                                        <p className='text-2xl font-bold text-black dark:text-white'><strong>{child.nom} {child.prénom}</strong></p>
                                        <p className='text-2xl font-bold text-black dark:text-white'>{child.lieu}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

const AddChild = ({nom, id}) => {
    // Valeurs parentales pour suggestions
    const parentLastName = localStorage.getItem('lastnamepartner') || '';
    const userLastName = localStorage.getItem('lastname') || '';
    const possibleLastNames = [parentLastName, userLastName].filter(Boolean).map(name => name.toUpperCase());
    const [lastName, setLastName] = useState('');
    const [filteredLastNames, setFilteredLastNames] = useState([]);
    const [showLastNameSuggestions, setShowLastNameSuggestions] = useState(false);
    const [firstName, setFirstName] = useState('');
    // const [birthPlace, setBirthPlace] = useState('');
    // const [suggestions, setSuggestions] = useState([]);
    // const GEOAPIFY_API_KEY = 'b9fa4117852c4c3392e6356bffd5fda7';
    // const [birthPlaceError, setBirthPlaceError] = useState('');

    // const handleSelectCity = (city) => {
    //     setBirthPlace(city);
    //     setSuggestions([]);
    //     setBirthPlaceError('');
    //     localStorage.setItem(`birthplacechild${id}`, city);
    // };

    useEffect(() => {
        // Mémoriser la valeur initiale si déjà présente
        if (lastName) {
            localStorage.setItem(`lastnamechild${id}`, lastName);
        }
    }, [id, lastName]);

    const handleChangeFirstName = (e) => {
        setFirstName(e.target.value);
        localStorage.setItem(`firstnamechild${id}`, e.target.value)
    };

    const handleLastNameInput = (e) => {
        const value = e.target.value.toUpperCase();
        setLastName(value);
        localStorage.setItem(`lastnamechild${id}`, value);
        // Filtrer suggestions
        if (value) {
            const filtered = possibleLastNames.filter(name =>
                name.includes(value)
            );
            setFilteredLastNames(filtered);
            setShowLastNameSuggestions(true);
        } else {
            setFilteredLastNames([]);
            setShowLastNameSuggestions(false);
        }
    };

    const handleSelectLastName = (name) => {
        setLastName(name);
        localStorage.setItem(`lastnamechild${id}`, name);
        setFilteredLastNames([]);
        setShowLastNameSuggestions(false);
    };

    // const handleChangeBirthPlace = async (e) => {
    //     const value = e.target.value;
    //     setBirthPlace(value);
    //     localStorage.setItem(`birthplacechild${id}`, value);
    //     if (value.length > 2) {
    //         try {
    //           const response = await fetch(
    //             `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(
    //               value
    //             )}&type=city&limit=5&apiKey=${GEOAPIFY_API_KEY}`
    //           );
    //           const data = await response.json();
        
    //           if (data.features) {
    //             setSuggestions(
    //               data.features.map((feature) => ({
    //                 name: feature.properties.city || feature.properties.name,
    //                 state: feature.properties.state || feature.properties.region,
    //                 country: feature.properties.country || feature.properties.country_code,
    //               }))
    //             );
    //             setBirthPlaceError('');
    //           } else {
    //             setSuggestions([]);
    //           }
    //         } catch (error) {
    //           console.error('Erreur Geoapify :', error);
    //           setSuggestions([]);
    //         }
    //       } else {
    //         setSuggestions([]);
    //       }
    // };

    return (
        <div className="w-full max-w-md rounded-lg p-4 shadow-md dark:bg-neutral-900 bg-gray-100">
            <h1 className='text-black dark:text-white text-xl font-semibold mb-4'>Enfant #{id + 1}</h1>
            <div className='mb-4'>
                <Label className='text-lg font-bold text-black dark:text-white' htmlFor={`child-lastname-${id}`}>Nom</Label>
                <Input
                    value={lastName}
                    onChange={handleLastNameInput}
                    type="text"
                    className="w-full"
                    id={`child-lastname-${id}`}
                    placeholder="Entrez le nom de l'enfant"
                />
                {showLastNameSuggestions && filteredLastNames.length > 0 && (
                    <ul
                    className="absolute z-10 bg-white border border-gray-300 w-full mt-1 rounded-md shadow-lg max-h-40 max-w-[17vh] overflow-y-auto"
                    style={{ boxSizing: 'border-box' }} // pour inclure la bordure dans la largeur
                    >
                    {filteredLastNames.map((name, idx) => (
                        <li
                        key={idx}
                        className="p-2 hover:bg-gray-500 cursor-pointer bg-gray-800 text-base"
                        onClick={() => handleSelectLastName(name)}
                        >
                        {name}
                        </li>
                    ))}
                    </ul>
                )}
            </div>
            <div className='mb-4'>
                <Label className='text-lg font-bold text-black dark:text-white' htmlFor={`child-firstname-${id}`}>Prénom</Label>
                <Input
                    value={firstName}
                    onChange={handleChangeFirstName}
                    type="text"
                    className="w-full"
                    id={`child-firstname-${id}`}
                    placeholder="Entrez le prénom de l'enfant"
                />
            </div>
            {/* <div className='mb-4'>
                <Label className='text-lg font-bold text-black dark:text-white' htmlFor={`child-birthplace-${id}`}>Lieu de naissance</Label>
                <Input
                    value={birthPlace}
                    onChange={handleChangeBirthPlace}
                    type="text"
                    className="w-full"
                    id={`child-birthplace-${id}`}
                    placeholder="Entrez le lieu de naissance"
                />
                {suggestions.length > 0 && (
                          <ul className="absolute z-10 bg-white border border-gray-300 w-full max-w-sm mt-1 rounded-md shadow-lg max-h-40 overflow-y-auto">
                            {suggestions
                            .filter(item => item.name && item.name.trim() !== '')
                            .map((item, idx) => (
                              <li
                                key={idx}
                                className="group relative overflow-hidden rounded-lg bg-gradient-to-r from-slate-800 to-slate-700 p-4 mb-2 shadow-lg border border-slate-600 hover:border-blue-400 cursor-pointer transition-all duration-300 ease-in-out hover:shadow-xl hover:scale-[1.02] hover:from-slate-700 hover:to-slate-600"
                                onClick={() => handleSelectCity(item.name)}
                              >
                                <div className="flex items-center justify-between">
                                  <div className="flex flex-col">
                                    <span className="font-semibold text-white text-lg group-hover:text-blue-300 transition-colors duration-200">
                                      {item.name}
                                    </span>
                                    <span className="text-slate-300 text-sm opacity-80 group-hover:opacity-100 transition-opacity duration-200">
                                      {item.state}, {item.country}
                                    </span>
                                  </div>
                                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                    <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                  </div>
                                </div>
                                
                                <div className="absolute inset-0 opacity-0 group-hover:opacity-20 bg-gradient-to-r from-transparent via-white to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-in-out"></div>
                              </li>
                            ))}
                          </ul>
                        )}
                {birthPlaceError && <p className="text-red-600 text-sm mt-1">{birthPlaceError}</p>}
            </div> */}
        </div>
    );
}

const PartnerKids = ({forShowData, isFormComplete, setFamilyTree, setShowParents}) => {
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    // const [birthPlace, setBirthPlace] = useState('');
    const [children, setChildren] = useState([]);
    // const [suggestions, setSuggestions] = useState([]);
    // const GEOAPIFY_API_KEY = 'b9fa4117852c4c3392e6356bffd5fda7';
    // const [birthPlaceError, setBirthPlaceError] = useState('');

    // const handleSelectCity = (city) => {
    //     setBirthPlace(city);
    //     setSuggestions([]);
    //     setBirthPlaceError('');
    //     localStorage.setItem('birthplacepartner', city);
    // };

    const addChildForm = () => {
        setChildren([...children, children.length]); // ← Ajoute un ID unique (l’index)
    };

    const handleChangeFirstName = (e) => {
        setFirstName(e.target.value);
        localStorage.setItem('firstnamepartner', e.target.value)
    };

    const handleChangeLastName = (e) => {
        const upperCaseValue = e.target.value.toUpperCase();
        setLastName(upperCaseValue);
        setTimeout(() => {
            localStorage.setItem('lastnamepartner', e.target.value)
        }, 100);
    };

    // const handleChangeBirthPlace = async (e) => {
    //     const value = e.target.value;
    //     setBirthPlace(value);
    //     localStorage.setItem('birthplacepartner', value);
    //     if (value.length > 2) {
    //         try {
    //           const response = await fetch(
    //             `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(
    //               value
    //             )}&type=city&limit=5&apiKey=${GEOAPIFY_API_KEY}`
    //           );
    //           const data = await response.json();
        
    //           if (data.features) {
    //             setSuggestions(
    //               data.features.map((feature) => ({
    //                 name: feature.properties.city || feature.properties.name,
    //                 state: feature.properties.state || feature.properties.region,
    //                 country: feature.properties.country || feature.properties.country_code,
    //               }))
    //             );
    //             setBirthPlaceError('');
    //           } else {
    //             setSuggestions([]);
    //           }
    //         } catch (error) {
    //           console.error('Erreur Geoapify :', error);
    //           setSuggestions([]);
    //         }
    //       } else {
    //         setSuggestions([]);
    //       }
    // };

    const handleSubmit = () => {
        forShowData(true)
        setFamilyTree(false)
        setShowParents(true)
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <div className="w-full max-w-md rounded-lg p-4 shadow-md dark:bg-neutral-900 bg-gray-100">
            <h1 className='text-black dark:text-white text-xl font-semibold mb-4'>Mettez le nom de votre conjoint(e)</h1>
            <div className='mb-4'>
                <Label className='text-lg font-bold text-black dark:text-white' htmlFor="mother-lastname">Nom de naissance</Label>
                <Input value={lastName} onChange={handleChangeLastName} type="text" className="w-full" id="mother-lastname" placeholder="Entrez le nom de votre conjoint(e)" />
            </div>
            <div className='mb-4'>
                <Label className='text-lg font-bold text-black dark:text-white' htmlFor="mother-firstname">Prénom</Label>
                <Input value={firstName} onChange={handleChangeFirstName} type="text" className="w-full" id="mother-firstname" placeholder="Entrez le prénom de votre conjoint(e)" />
            </div>
            {/* <div className='mb-4'>
                <Label className='text-lg font-bold text-black dark:text-white' htmlFor="mother-birthplace">Lieu de naissance</Label>
                <Input value={birthPlace} onChange={handleChangeBirthPlace} type="text" className="w-full" id="mother-birthplace" placeholder="Entrez le lieu de naissance de votre conjoint(e)" />
                {suggestions.length > 0 && (
                  <ul className="absolute z-10 bg-white border border-gray-300 w-full max-w-sm mt-1 rounded-md shadow-lg max-h-40 overflow-y-auto">
                    {suggestions
                    .filter(item => item.name && item.name.trim() !== '')
                    .map((item, idx) => (
                      <li
                        key={idx}
                        className="group relative overflow-hidden rounded-lg bg-gradient-to-r from-slate-800 to-slate-700 p-4 mb-2 shadow-lg border border-slate-600 hover:border-blue-400 cursor-pointer transition-all duration-300 ease-in-out hover:shadow-xl hover:scale-[1.02] hover:from-slate-700 hover:to-slate-600"
                        onClick={() => handleSelectCity(item.name)}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex flex-col">
                            <span className="font-semibold text-white text-lg group-hover:text-blue-300 transition-colors duration-200">
                              {item.name}
                            </span>
                            <span className="text-slate-300 text-sm opacity-80 group-hover:opacity-100 transition-opacity duration-200">
                              {item.state}, {item.country}
                            </span>
                          </div>
                          <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                            <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                          </div>
                        </div>
                        
                        <div className="absolute inset-0 opacity-0 group-hover:opacity-20 bg-gradient-to-r from-transparent via-white to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-in-out"></div>
                      </li>
                    ))}
                  </ul>
                )}
                {birthPlaceError && <p className="text-red-600 text-sm mt-1">{birthPlaceError}</p>}
            </div> */}
            {children.map((id) => (
                <AddChild key={id} id={id} />
            ))}
            <div className="flex flex-col justify-center sm:flex-row gap-4 mt-4">
                <button
                    type="button"
                    onClick={addChildForm}
                    className="py-3 px-6 text-sm font-medium rounded-lg border border-transparent bg-blue-100 text-blue-800 hover:bg-blue-200 dark:text-green-400 dark:bg-green-800/30 dark:hover:bg-green-800/20"
                >
                    Ajoutez votre enfant
                </button>
            </div>
            <div className="flex flex-col justify-center sm:flex-row gap-4 mt-4">
                <button
                    type="button"
                    onClick={handleSubmit}
                    disabled={!isFormComplete}
                    className="py-3 px-6 text-sm font-medium rounded-lg border border-transparent bg-blue-100 text-blue-800 hover:bg-blue-200 dark:text-blue-400 dark:bg-blue-800/30 dark:hover:bg-blue-800/20"
                >
                    Entrer
                </button>
            </div>

        </div>
    );
}

export default PartnerKids;

export {ShowPartnerKids}